"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resguardoConverter = void 0;
const fecha_1 = require("../utils/fecha");
const resguardoConverter = {
    toFirestore(resguardo) {
        return resguardo;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            activo: data.activo,
            emisorId: data.emisorId,
            localId: data.localId,
            fecha: data.fecha,
            fechaString: data.fechaString ?? (0, fecha_1.utilFechaConvertirNumeroAAAAMMDD)(data.fecha),
            receptorId: data.receptorId,
            receptorString: data.receptorString,
            moneda: data.moneda,
            cotizacion: data.cotizacion ?? 1,
            comprobante: data.comprobante,
            retenciones: data.retenciones,
            referencias: data.referencias,
            observaciones: data.observaciones,
            valor: data.valor,
            cfeId: data.cfeId,
            cfeNumero: data.cfeNumero,
            cfeSerie: data.cfeSerie,
            cfeTipo: data.cfeTipo,
            cfeMotivoRechazoDGI: data.cfeMotivoRechazoDGI,
            cfeMotivoRechadoReceptor: data.cfeMotivoRechadoReceptor,
            cfeEstadoDGI: data.cfeEstadoDGI,
            cfeEstadoReceptor: data.cfeEstadoReceptor,
            resguardoCancelanteId: data.resguardoCancelanteId ?? "",
            resguardoCanceladoId: data.resguardoCanceladoId ?? "",
            resguardoCancelanteComprobante: data.resguardoCancelanteComprobante ?? data.resguardoCancelante,
            resguardoCanceladoComprobante: data.resguardoCanceladoComprobante ?? data.resguardoCancelado
        };
    }
};
exports.resguardoConverter = resguardoConverter;
